export default {
  label: {
    title: 'Global filters',
    description: 'Here you define the filtering rules for the entire dashboard.',
    notClassified: 'Not Classified',
    filters: {
      groups: 'Groups',
      themes: 'Themes',
      tags: 'Tags',
      status: 'Status',
      repliers: 'Repliers',
      contract: 'Contract',
      bot: 'Bot',
      channels: 'Channels',
      operators: 'Agents',
      teams: 'Queues',
    },
    button: {
      cancelButton: 'Cancel',
      confirmButton: 'Apply',
      clearButton: 'Clear all',
      primaryButton: 'Confirm',
    },
    listening: {
      subtitle: 'Posts',
      session: {
        what: 'What',
        when: 'When',
        where: 'Where',
        who: 'Who',
      },
    },
    sac: {
      subtitle: 'Proprietary metrics and Smart Care',
    },
    blip: {
      subtitle: 'Blip',
    },
    desk: {
      subtitle: 'Human support',
    },
  },
};
